import { FC } from "react";

import './Background.scss';


const Background: FC = () => {

	return (
		<>
			<div className="Background"/>
			<div className="Background-bottomShadow">
				<div className="Background-bottomShadow-text">
					<div>Z0MMA.EX3...PR0T0C0L...L0ADED///</div>
					<div>{'>>'}[ERR:UNDEFINED PROTOCOL]...OVERRIDE=TRUE</div>
					<div># SIGNAL NOISE // CONNECTION STABLE</div>
					<div>░▒▓ SYSTEM DISTORTION DETECTED ▓▒░</div>
					<div>{'>'} TRANSMISSION: CORRUPTED DATA FLOW</div>
					<div>{'>'} [SYNC] [SYNC] [SYNC]...</div>
				</div>
			</div>
		</>
	)
}

export default Background;